import { useLaunchParams } from "@tma.js/sdk-react";

const ROUTE_PREFIX = "route_";

/**
 * Decodes a startapp parameter into a route path.
 *
 * Encoding scheme (only [A-Za-z0-9_-] allowed in startapp):
 *   - Path part (before first "-"): "_" → "/"
 *   - Query part (after first "-"):  "_" → "=", "-" → "&"
 *
 * Examples:
 *   "route_account_profile"               → "/account/profile"
 *   "route_account-tab_settings"          → "/account?tab=settings"
 *   "route_account_profile-tab_x-page_2"  → "/account/profile?tab=x&page=2"
 *
 * Returns null if the param is absent or not a route param.
 */
export const decodeStartappRoute = (param: string | undefined): string | null => {
  if (!param?.startsWith(ROUTE_PREFIX)) {
    return null;
  }

  const encoded = param.slice(ROUTE_PREFIX.length);
  const dashIndex = encoded.indexOf("-");

  if (dashIndex === -1) {
    return `/${encoded.replaceAll("_", "/")}`;
  }

  const pathPart = encoded.slice(0, dashIndex).replaceAll("_", "/");
  const queryPart = encoded
    .slice(dashIndex + 1)
    .replaceAll("-", "&")
    .replaceAll("_", "=");

  return `/${pathPart}?${queryPart}`;
};

export const useStartappRedirect = (): string | null => {
  const { tgWebAppStartParam } = useLaunchParams();
  return decodeStartappRoute(tgWebAppStartParam);
};
